import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";

interface StackChartLoaderProps {
  numberOfBars?: number;
  numberOfStacks?: number;
}

const StackChartLoader: React.FC<StackChartLoaderProps> = ({
  numberOfBars = 6,
  numberOfStacks = 5,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={4} width="100%">
      <Box>
        <Typography variant="h6">
          <Skeleton width="50%" height={24} />
        </Typography>
        <Box width="100%" display="flex" justifyContent="flex-end" gap={2}>
          {[...Array(numberOfStacks)].map((itm) => (
            <Skeleton key={itm} variant="text" width={80} height={20} />
          ))}
        </Box>
      </Box>

      <Box width="100%" height="23rem" display="flex" flexDirection="column">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          height="100%"
        >
          {[...Array(numberOfBars)].map((barItm) => {
            const totalHeight = 100;
            const stackHeights = Array.from({ length: numberOfStacks }, () =>
              Math.floor(Math.random() * (totalHeight / numberOfStacks) + 5)
            );

            return (
              <Box
                key={barItm}
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="center"
                width="12%"
                height="100%"
              >
                <Box
                  display="flex"
                  flexDirection="column-reverse"
                  gap={0.5}
                  width="100%"
                  height="100%"
                >
                  {stackHeights.map((height, stackIndex) => (
                    <Skeleton
                      key={stackIndex + height}
                      variant="rectangular"
                      width="100%"
                      height={`${height}%`}
                    />
                  ))}
                </Box>
                <Skeleton
                  key={barItm}
                  variant="text"
                  height={20}
                  sx={{
                    mt: 1,
                    width: { xs: "100%", sm: "20%" },
                  }}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default StackChartLoader;
